import { render, staticRenderFns } from "./sellOrder.vue?vue&type=template&id=631b6256&scoped=true&"
import script from "./sellOrder.vue?vue&type=script&lang=js&"
export * from "./sellOrder.vue?vue&type=script&lang=js&"
import style0 from "./sellOrder.vue?vue&type=style&index=0&id=631b6256&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b6256",
  null
  
)

export default component.exports